import { render, staticRenderFns } from "./DatePicker2.vue?vue&type=template&id=38780c13&scoped=true&"
import script from "./DatePicker2.vue?vue&type=script&lang=js&"
export * from "./DatePicker2.vue?vue&type=script&lang=js&"
import style0 from "./DatePicker2.vue?vue&type=style&index=0&id=38780c13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38780c13",
  null
  
)

export default component.exports